<template>
  <div id="menu">
    <div id="mobile-menu">
      <img v-if="style=='vm'"
        @click="viewPage('Dashboard')"
        class="logo vm" src="../assets/vm/VM-logo1.svg"
      />
      <img v-if="style=='ox'"
        @click="viewPage('Dashboard')"
        class="logo oxby" src="../assets/ox/OX-logo2.svg"
      />
      <img v-if="style=='bvs'"
        @click="viewPage('Dashboard')"
        class="logo bvs" src="../assets/bvs/BVS-logo2.svg"
      />
      <img v-if="style=='db'"
        @click="viewPage('Home');"
        class="logo bvs" src="../assets/db/DB-logo2.svg"
      />
      <button @click="showMenu = !showMenu" style="position: relative;">
        <awesomeIcon icon="bars"/> Menu
        <div v-if="unread.length > 0" class="indicator">
          <span class="count">{{unread.length}}</span>
        </div>
      </button>
    </div>

    <div id="sidemenu" :class="['container', showMenu ? 'show' : 'hide']">
      <img v-if="style=='vm'" class="logo" src="../assets/vm/VM-logo1.svg" />
      <img v-if="style=='ox'" class="logo" src="../assets/ox/OX-logo2.svg" />
      <img v-if="style=='bvs'" class="logo" src="../assets/bvs/BVS-logo2.svg" />
      <img v-if="style=='db'"
        class="logo" style="max-width:70px" src="../assets/db/DB-logo2.svg"
        @click="viewPage('Home');"
      />

      <span class="close-mobile-menu" @click="showMenu = false">
        Sluiten <awesomeIcon icon="times"/>
      </span>

      <template v-if="view != 'Intake'">
        <ul v-if="currentPort" style="margin-bottom:40px;">
          <li @click="viewPage('Dashboard');showMenu = false;"
            :class="[{'active': view === 'Dashboard'}, 'button']"
          >
            <awesomeIcon icon="chart-pie"/> Overzicht {{port}}
          </li>
          <li v-if="
              currentPort.status != 3
              && (
                new Date(currentPort.date) > new Date(new Date().setDate(new Date().getDate()-7))
                || currentPort.bank == 'BAL'
                || currentPort.bank == 'GIRO'
              )
            "
            @click="viewPage('Positions');showMenu = false;"
            :class="[{'active': view === 'Positions'}, 'button']"
          >
            <awesomeIcon icon="chart-line"/> Posities
          </li>
          <li v-if="
              currentPort.status != 3
              && (
                new Date(currentPort.date) > new Date(new Date().setDate(new Date().getDate()-7))
                || currentPort.bank == 'BAL'
                || currentPort.bank == 'GIRO'
              )
            "
            @click="viewPage('Mutations');showMenu = false;"
            :class="[{'active': view === 'Mutations'}, 'button']"
          >
            <awesomeIcon icon="exchange-alt"/> Mutaties
          </li>
          <li
            @click="viewPage('Reports');showMenu = false;"
            :class="[{'active': view === 'Reports'}, 'button']"
          >
            <awesomeIcon icon="file-download"/> Rapportage
          </li>
        </ul>

        <ul>
          <li
            v-if="role == 2"
            class="button" @click="viewPage('AtpStart');showMenu = false;"
            :class="[{'active' : 'AtpStart' == view}, 'button']"
          >
            <awesomeIcon icon="home"/> Startpagina
          </li>

          <li
            v-if="role == 2"
            @click="viewPage('AtpCustomers');showMenu = false;"
            :class="[{'active' : view === 'AtpCustomers'}, 'button']"
          >
            <awesomeIcon icon="users"/> Klanten
          </li>
          <li
            v-if="role == 2"
            @click="viewPage('AtpUsers');showMenu = false;"
            :class="[{'active' : view === 'AtpUsers'}, 'button']"
          >
            <awesomeIcon icon="tasks"/> Onboardings
          </li>
          <li v-else-if="role == 1 || mandates.length > 0 || showMandates"
            @click="viewPage('Mandates');showMenu = false;"
            :class="[{'active' : view === 'Mandates'}, 'button']"
          >
            <awesomeIcon icon="user-friends"/> {{
              role == 1 || showMandates ? 'Mijn klanten' : 'Mijn adviseur(s)'
            }}
          </li>

          <li
            v-if="role == 2"
            @click="viewPage('AtpGoals');showMenu = false;"
            :class="[{'active' : view === 'AtpGoals'}, 'button']"
          >
            <awesomeIcon icon="th"/> Offerte maken
          </li>
          <li
            v-else
            @click="viewPage('Home');showMenu = false;"
            :class="[{'active' : view === 'Home'}, 'button']"
          >
            <awesomeIcon :icon="style == 'db' ? 'fa-regular fa-circle-dot' : 'folder-open'"/>
            Mijn {{style == 'db' ? 'doelen' : 'portefeuilles'}}
          </li>

          <li
            v-if="role == 1 || role == 2"
            @click="viewPage('DocCenter');showMenu = false;"
            :class="[{'active': view === 'DocCenter'}, 'button']"
          >
            <awesomeIcon icon="file"/> Documentencentrum
          </li>

          <li
            @click="viewPage('Messages');showMenu = false;"
            :class="[{'active': view === 'Messages'}, 'button']"
          >
            <awesomeIcon icon="envelope"/> Berichten
            <span v-if="unread.length > 0" class="unreadBadge">{{unread.length}}</span>
          </li>

          <li class="button" @click="help = true" v-if="Number(role) !== 2">
            <awesomeIcon icon="question-circle"/> Contact opnemen
          </li>

          <li
            v-if="role == 2"
            class="button" @click="viewPage('atpTools');showMenu = false;"
            :class="[{'active' : view === 'atpTools'}, 'button']"
          >
            <awesomeIcon icon="fa-wrench"/> Tools
          </li>

          <li v-if="role >= 0"
            @click="viewPage('ProfilePage');showMenu = false;"
            :class="[{'active': view === 'ProfilePage'}, 'button']"
          >
            <awesomeIcon icon="user"/> Mijn gegevens
          </li>

          <li class="button" @click="logout" v-if="!sdk.isBecome">
            <awesomeIcon icon="sign-out-alt" flip="horizontal"/> Uitloggen
          </li>
        </ul>
      </template>
    </div>

    <contactForm v-if="help" @close="help = false" />
  </div>
</template>

<script>
import { find } from 'lodash-es';

export default {
  name: 'MainMenu',

  data() {
    return {
      portFilter: '',
      help: false,
      msg: { msg: null, type: 'notice' },
      style: process.env.VUE_APP_STYLE,
      timer: null,
      dropdownlist1: false,
      key: null,
      files: null,
      firstLoad: false,
      showMandates: false,
      showMenu: false,
    };
  },
  computed: {
    ports() {
      return this.$store.state.ports;
    },
    intakes() {
      return this.$store.state.intakes;
    },
    mandates() {
      return this.$store.state.mandates;
    },
    view() {
      return this.$store.state.currentView;
    },
    port() {
      return this.$store.state.currentPort;
    },
    role() {
      return this.$store.state.role;
    },
    unread() {
      return this.$store.state.unread;
    },
    currentPort() {
      return find(this.$store.state.ports, {
        id: this.$store.state.currentPort,
      });
    },
  },
  watch: {
    dropdownlist1() {
      if (!this.$refs.portFilter && this.ports.length > 10) {
        this.$nextTick(() => {
          this.$refs.portFilter.focus();
        });
      }
    },
  },
  created() {
    this.updateMenu();
    this.timer = setInterval(this.updateMenu, 1 * 60 * 1000);
  },
  methods: {
    openIntake(id) {
      window.location.href = `?intake=${id}`;
    },
    portButton() {
      this.dropdownlist1 = !this.dropdownlist1;
    },
    clearMessage() {
      this.msg = { msg: null, type: 'notice' };
    },
    logout() {
      if (this.sdk.isBecome) {
        this.sdk.unbecome(() => {
          window.location.reload();
        });
      } else {
        this.sdk.logout();
        window.location.reload();
      }
    },
    viewPage(page) {
      this.$store.state.currentView = page;
    },
    choosePort(e) {
      this.$store.state.currentPort = e;
      this.$store.state.currentView = 'Dashboard';
    },
    choosePortMobile(e) {
      this.$store.state.currentPort = e;
      this.$store.state.currentView = 'Dashboard';
    },
    updateMenu() {
      this.sdk.getIntakes((responseIntakes) => {
        this.$store.state.intakes = responseIntakes.data;
        this.sdk.getPorts((response) => {
          if (response.status === 200) {
            for (let i = 0; i < response.data.length; i += 1) {
              if (
                new Date(response.data[i].date) <= new Date(
                  new Date().setDate(new Date().getDate() - 7),
                )
                && response.data[i].bank !== 'BAL'
              ) {
                response.data[i].value = 0;
              }
            }
            this.$store.state.ports = response.data;
            if (!this.firstLoad) {
              this.firstLoad = true;
              if (response.data.length === 1) {
                this.$store.state.currentPort = response.data[response.data.length - 1].id;
              }
              if (this.$store.state.currentView !== 'Intake') {
                if (this.$store.state.ports.length !== 1) {
                  if (Number(this.$store.state.role) === 2) {
                    this.$store.state.currentView = 'AtpStart';
                  } else {
                    this.$store.state.currentView = 'Home';
                  }
                } else {
                  this.$store.state.currentView = 'Dashboard';
                }
              }
            }
          } else {
            this.logout();
          }
        });
      });
      this.sdk.getMandates((response) => {
        if (response.status === 200) {
          this.$store.state.mandates = response.data.advisedBy || [];
          this.showMandates = response.data.advisorFor.length > 0;
        }
      });
      this.sdk.getUnreadMessages((response) => {
        if (response.status === 200) {
          this.$store.state.unread = response.data;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 988px) {
  .portnr {
    color: #fff;
    padding: 0px 20px 40px 20px;
    text-align: center;
  }
  #sidemenu {
    width: 220px;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    background-color:$color-background;
    z-index: 1;
    ul {
      margin: 0;
      padding: 0;
      list-style-type: none;
    }
    #adminmenu {
      margin: 40px 0;
    }
    .button {
      padding: 12px 10px 12px 70px;
      width: 100%;
      box-sizing: border-box;
      color: $color-txt;
      display: block;
      cursor: pointer;
      text-decoration: none;
      line-height: 1em;
      background-image: linear-gradient(90deg, $color-background, lighten($color-background, 10%));
      transition: background-image .2s;
      position: relative;
      text-align: left;
      opacity: .8;
      &:hover {
        background-image: linear-gradient(
          90deg,
          lighten($color-background, 10%),
          lighten($color-background, 10%)
        );
        opacity: 1;
      }
      svg {
        position: absolute;
        top: 13px;
        left: 40px;
      }
      .notification {
        position: absolute;
        top: 5px;
        left: 49px;
      }
    }
    .logo {
      width: 100px;
      height: 100px;
      margin: 40px auto;
      display: block;
    }
    li {
      &.active {
        color: $color-highlight;
        opacity: 1;
      }
    }
    .close-mobile-menu {
      display: none;
    }
    .dropdown {
      display: block;
      .dropdown-list {
        margin: 0 10px;
      }
    }
    .unreadBadge {
      left: 135px;
    }
  }
}

@media screen and (max-width: 988px) {
  #sidemenu .logo {
    display: none;
  }
  #sidemenu.show {
    display: block;
  }
  #sidemenu.hide {
    display: none;
  }
  ul, li {
    margin: 0;
    padding: 0;
    list-style-type: none;
    line-height: 1em;
    display: block;
    margin: 10px;
    padding: 10px;
    position: relative;
    color: inherit;
  }
  #sidemenu {
    overflow: auto;
    background: rgba(0, 0, 0, 0.9);
    z-index: 99;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    color: #fff;
    padding: 40px 20px;
    .button {
      // padding: 0;
      margin: 0;
      text-align: left;
      background-color: transparent;
    }
    .close-mobile-menu {
      cursor: pointer;
      top: 0;
      right: 0;
      position: absolute;
      padding: 20px 30px;
      color: #fff;
      z-index: 99;
    }
    .dropdown {
      display: none;
    }
    li {
      cursor: pointer;
    }
    svg {
      color: $color-highlight;
      margin-right: 5px;
    }
    .button .notification {
      position: absolute;
      top: 5px;
      left: 18px;
    }
  }
}

.mobile-hidden {
   @media #{$mobile} {
     display: none;
   }
}

#mobile-menu {
  display: none;
  @media screen and (max-width: 988px) {
    display: block;
    position: fixed;
    background-color: $color-background;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1;
    overflow: hidden;
    padding: 0 10px;
    margin-top: -50px;
    padding-top: 50px;
  }
  select {
    float: right;
    width: auto;
    margin: 10px;
    height: 35px;
  }
  button {
    float: right;
    margin: 10px;
    height: 35px;
  }
  .logo {
    width: 35px;
    height: 35px;
    margin: 10px;
    float: left;
    &.oxby {
      width: 70px;
    }
  }
  .indicator {
    position: absolute;
    top: -10%;
    right: -10%;
    left: 90%;
    bottom: 60%;
    background-color: red;
    border-radius: 50%;
  }
  .count {
    color: white;
    font-weight: 600;
  }
}

#intakemenu {
  .button {
    padding-left: 30px;
  }
  .sub {
    color: $color-highlight;
    svg {
      opacity: 0;
    }
  }
}
.unreadBadge {
  background-color: red;
  color: white;
  text-align: center;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  float: right;
  position: absolute;
  top: 10px;
  left: 100px;
  font-size: 11px;
}
</style>
